<template>
  <div :class="['sw-toast', `sw-toast--${severity}`, `sw-toast--${variant}`]" @mouseenter="pauseTimer" @mouseleave="resumeTimer" role="alert">
    <span class="sw-toast__icon material-icons">{{ iconName }}</span>
    <div class="sw-toast__content">
      <span class="sw-toast__title">{{ title }}</span>
      <span v-if="description" class="sw-toast__description" v-dompurify-html="description"></span>
    </div>
    <button v-if="action" class="sw-toast__action" @click="handleAction">
      <span v-if="action.icon" class="material-icons">{{ action.icon }}</span>
      {{ action.text }}
    </button>
    <button class="sw-toast__close material-icons" @click="close" aria-label="Close notification">close</button>
  </div>
</template>

<script>
const DEFAULT_ICONS = {
  default: 'notifications',
  info: 'info',
  success: 'check_circle',
  warning: 'warning',
  danger: 'error'
}

export default {
  name: 'ToastItem',
  props: {
    id: { type: Number, required: true },
    icon: { type: String },
    title: { type: String, required: true },
    description: { type: String },
    severity: {
      type: String,
      default: 'default',
      validator: v => ['default', 'info', 'success', 'warning', 'danger'].includes(v)
    },
    variant: {
      type: String,
      default: 'regular',
      validator: v => ['regular', 'container'].includes(v)
    },
    duration: {
      type: Number,
      default: 5000
    },
    action: {
      type: Object
    }
  },
  data() {
    return {
      timerId: null,
      remaining: this.duration,
      startedAt: null
    }
  },
  computed: {
    iconName() {
      return this.icon || DEFAULT_ICONS[this.severity]
    }
  },
  mounted() {
    this.startTimer()
  },
  beforeDestroy() {
    clearTimeout(this.timerId)
  },
  methods: {
    startTimer() {
      if (!this.remaining || this.remaining <= 0) return
      this.startedAt = Date.now()
      this.timerId = setTimeout(() => this.close(), this.remaining)
    },
    pauseTimer() {
      if (!this.timerId) return
      clearTimeout(this.timerId)
      this.timerId = null
      this.remaining -= Date.now() - this.startedAt
    },
    resumeTimer() {
      this.startTimer()
    },
    handleAction() {
      if (this.action && this.action.onClick) this.action.onClick()
      this.close()
    },
    close() {
      clearTimeout(this.timerId)
      this.$emit('close')
    }
  }
}
</script>
